import React from 'react';
import ConciergeProgramForm from './ConciergeProgramForm';
import { CONCIERGE_PROGRAMS } from '../data/conciergePrograms';

// Dr. Mavroson's concierge programs. All the logic lives in
// ConciergeProgramForm; these bind a program definition to a route.
const AdvancedPeptideForm = () => <ConciergeProgramForm program={CONCIERGE_PROGRAMS.advancedPeptide} />;
export const AdvancedWeightLossForm = () => <ConciergeProgramForm program={CONCIERGE_PROGRAMS.advancedWeightLoss} />;
export const AdvancedLongevityForm = () => <ConciergeProgramForm program={CONCIERGE_PROGRAMS.advancedLongevity} />;

export default AdvancedPeptideForm;
